export function useFacebookPixel(pixelId: string) {
  const loadPromise = shallowRef<Promise<void> | null>(null)
  /**
   * 加载 Facebook SDK
   */
  function loadSdk() {
    if (loadPromise.value) return loadPromise.value
    if (typeof window === 'undefined') return Promise.resolve()

    loadPromise.value = new Promise<void>((resolve) => {
      if (window.fbq) {
        resolve()
        return
      }
      ;(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = true
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = true
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
        t.onload = () => resolve()
        t.onerror = () => {
          console.error('Facebook Pixel SDK 加载失败')
          resolve()
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
      )
    })
    return loadPromise.value
  }

  /**
   * 等待 _fbc（最多等待 3 秒）
   */
  function waitForFbcWithTimeout(timeout = 1000): Promise<string | null> {
    return new Promise((resolve) => {
      const start = performance.now()

      const check = () => {
        const match = document.cookie.match(/_fbc=([^;]+)/)
        if (match) {
          resolve(match[1])
          return
        }
        // 超时：返回 null
        if (performance.now() - start >= timeout) {
          resolve(null)
          return
        }
        requestAnimationFrame(check)
      }
      check()
    })
  }

  /**
   * 初始化 Pixel + PageView + 等待 _fbc（带 3 秒超时）
   */
  async function initAndWaitFbc() {
    await loadSdk()
    fbq('init', pixelId)
    fbq('track', 'PageView') // PageView 会触发 _fbc 写入
    // ⭐ 最多等待 3 秒
    const fbc = await waitForFbcWithTimeout()
    return true // 有可能是 null（超时）
  }
  return {
    initAndWaitFbc
  }
}
